import { primary, primary700 } from './globalStyles'

export const CustomButton = {
  baseStyle: {
    _focus: {
      boxShadow: 'none'
    }
  },
  variants: {
    primary: {
      backgroundColor: primary,
      border: 'none',
      color: 'white',
      _hover: {
        backgroundColor: primary700
      },
      _focus: {
        backgroundColor: primary700
      },
      _disabled: {
        opacity: 0.5
      }
    },
    white: {
      backgroundColor: 'white',
      border: '1px solid',
      borderColor: 'gray.200',
      color: 'gray.700',
      _hover: {
        backgroundColor: 'gray.100'
      },
      _focus: {
        backgroundColor: 'gray.100'
      },
      _disabled: {
        opacity: 0.5
      }
    }
  }
}
